import { render, staticRenderFns } from "./InputError.vue?vue&type=template&id=81b4a118&scoped=true"
import script from "./InputError.vue?vue&type=script&lang=js"
export * from "./InputError.vue?vue&type=script&lang=js"
import style0 from "./InputError.vue?vue&type=style&index=0&id=81b4a118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_babel-core@7.0.0-bridge.0_@babel+core@7.28._1eb1b9dda9fe6d233009820956254809/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b4a118",
  null
  
)

export default component.exports